import React from 'react';
import { Paper, Stack, Button } from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  NavigateBefore as NavigateBeforeIcon,
  Save as SaveIcon,
} from '@mui/icons-material';

/**
 * Centralized bottom navigation component for the ChunkEditor workflow
 * Handles navigation between steps and actions (Cancel, Back, Next, Save)
 */
export default function FixedBottomNavigation({
  step = 'edit', // 'edit' | 'copyright'
  onBack,
  onNext,
  onCancel,
  onSave,
  saving = false,
  disabled = false,
}) {
  return (
    <Paper
      elevation={8}
      sx={{
        p: 2,
        borderRadius: 0,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        zIndex: 10,
      }}
    >
      <Stack 
        direction="row" 
        spacing={1.5} 
        sx={{ 
          mx: 'auto',
          justifyContent: 'flex-end'
        }}
      >
        {/* Cancel button - always visible */}
        <Button
          variant="outlined"
          color="error"
          onClick={onCancel}
          size="large"
          disabled={saving}
        >
          Cancel
        </Button>

        {/* Back button - always visible, disabled on edit step */}
        <Button
          variant="contained"
          startIcon={<NavigateBeforeIcon />}
          onClick={onBack}
          size="large"
          disabled={step === 'edit' || saving}
        >
          Back
        </Button>

        {/* Next button - always visible, disabled on copyright step */}
        <Button
          variant="contained"
          endIcon={<NavigateNextIcon />}
          size="large"
          onClick={onNext}
          disabled={step === 'copyright' || disabled}
        >
          Assign Copyright Holders
        </Button>

        {/* Save button - always visible, disabled on edit step */}
        <Button
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          size="large"
          onClick={onSave}
          disabled={step === 'edit' || saving || disabled}
        >
          {saving ? 'Saving...' : 'Save & Process'}
        </Button>
      </Stack>
    </Paper>
  );
}